module.exports = __webpack_public_path__ + "img/productsComB.185504b2.png";